import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ChiSono from "./pages/ChiSono";
import Servizi from "./pages/Servizi";
import PrenotaAppuntamento from "./pages/PrenotaAppuntamento";
import Contatti from "./pages/Contatti";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import "./App.css";
import Privacy from "./pages/Privacy";
import CookiePolicy from "./pages/CookiePolicy";
import { usePageTracking } from "./hooks/usePageTracking";
import ScrollToTop from "./components/ScrollOnTop";
import { Analytics } from "@vercel/analytics/react"
import Faq from "./pages/Faq";

function App() {
  usePageTracking();

  return (
    <div className="App">
      <Analytics/>
      <ScrollToTop/>
      <Navbar />
      <div
        className="content"
        style={{
          marginTop: "72px",
          backgroundColor: "var(--paper)",
        }}
      >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<ChiSono />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route
              path="/prenota-appuntamento"
              element={<PrenotaAppuntamento />}
            />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/faq" element={<Faq />} />
          </Routes>
      </div>
      <Footer />
      <CookieBanner />
    </div>
  );
}

export default App;
